<script>
  import SvelteMarkdown from "svelte-markdown";
  import MarkdownDummy from "../helpers/MarkdownDummy.svelte";
  import MarkdownLink from "../helpers/MarkdownLink.svelte";

  export let content;
  export let style = null;
  const source = Array.isArray(content) ? content.join("\n") : content;

  export const renderers = {
    heading: MarkdownDummy,
    image: MarkdownDummy,
    table: MarkdownDummy,
    tablehead: MarkdownDummy,
    tablebody: MarkdownDummy,
    tablerow: MarkdownDummy,
    tablecell: MarkdownDummy,
    hr: MarkdownDummy,
    html: MarkdownDummy,
    blockquote: MarkdownDummy,
    link: MarkdownLink,
  };

  import { ci } from "../store";

  const font = $ci.page.paragraph.font
    ? `--font: ${$ci.page.paragraph.font};`
    : "";
  const fontWeight = $ci.page.paragraph.font_weight
    ? `--fontWeight: ${$ci.page.paragraph.font_weight};`
    : "";
  const fontStyle = $ci.page.paragraph.font_style
    ? `--fontStyle: ${$ci.page.paragraph.font_style};`
    : "";
  const lineHeight = $ci.page.paragraph.line_height
    ? `--lineHeight: ${$ci.page.paragraph.line_height};`
    : "";
  const size = $ci.page.paragraph.font
    ? `--size: ${$ci.page.paragraph.size};`
    : "";
  const styleFonts = `${font}${size}${fontWeight}${fontStyle}`;

  style ? (style += " " + styleFonts) : (style = styleFonts);
</script>

<div class="locked-text" {style}>
  <SvelteMarkdown {source} {renderers} />
</div>

<style>
  .locked-text {
    text-align: justify;
    font-family: var(--font);
    font-size: var(--size);
    font-weight: var(--fontWeight);
    font-style: var(--fontStyle);
    line-height: var(--lineHeight);
    white-space: pre-line;
  }
</style>
